import { render } from "./AddCollegiate.vue?vue&type=template&id=818c1bb2"
import script from "./AddCollegiate.vue?vue&type=script&lang=js"
export * from "./AddCollegiate.vue?vue&type=script&lang=js"

import "./AddCollegiate.vue?vue&type=style&index=0&id=818c1bb2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__